var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPic7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85.63 93.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffed4a;}.cls-2{fill:none;stroke:#343a40;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}.cls-3{fill:#fff;}.cls-4{fill:#baa1de;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.28,12.57S-5.45,49.83.35,58.11s85.28,44.72,85.28,33.12S74.87,8.43,63.28,12.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.36,21.69s-37-25.12-39.68-20S14.12,48.83,20,45.78,51.51,26.49,46.36,21.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M61.59,64.85s-2-22.68-4.78-22S34.87,54.15,37.25,56.37C40.51,59.41,61.56,68.3,61.59,64.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M49.78,90.09s-2.05-22.67-4.79-22S23.06,79.4,25.43,81.61C28.69,84.66,49.74,93.54,49.78,90.09Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPic7);
export default __webpack_public_path__ + "static/media/Pic7.52f7319c076054543341aa55d14aacd4.svg";
export { ForwardRef as ReactComponent };